import React from 'react';
import { connect } from 'react-redux';
import { getValues } from 'pages/store/selectors';

import get from 'lodash/get';

const Completed = ({ show }) => (
  <div style={{ display: show ? 'block' : 'none' }}>
    <div className="cr-mb-2">
      <img
        src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/ecom/launch4_sm.gif"
        width="400"
        height="322"
        alt="eCom provisioning completed"
      />
    </div>
  </div>
);

const mapStateToProps = state => ({
  ecomProvisioning: get(getValues('ecomConfirmation')(state), 'ecomProvisioning', {}),
});

export default connect(mapStateToProps)(Completed);
